import { useRef } from 'react';
// @mui
import { Box } from '@mui/material';
//
import { BISQUE, STAGE } from '../../../theme/stage';
import BisqueRing from '../primitives/BisqueRing';
import { useRevealed } from '../primitives/Reveal';

// ----------------------------------------------------------------------

const CENTRED = {
  position: 'absolute',
  left: '50%',
  top: '50%',
  aspectRatio: '1',
  transform: 'translate(-50%, -50%)',
} as const;

const DOT = `radial-gradient(circle at 32% 28%, ${STAGE.bisqueLight} 0%, ${STAGE.bisque} 52%, ${STAGE.bisqueShade} 100%)`;

export default function NextArt() {
  const orbitRef = useRef<HTMLDivElement>(null);

  const revealed = useRevealed(orbitRef);

  return (
    <>
      <Box ref={orbitRef} sx={{ ...CENTRED, width: '45%' }}>
        <Box component="svg" sx={{ position: 'absolute', inset: 0, width: '100%', height: '100%' }}>
          <circle
            cx="50%"
            cy="50%"
            r="49.5%"
            fill="none"
            stroke={STAGE.line}
            strokeWidth={1}
            strokeDasharray="2 6"
          />
        </Box>

        <Box
          data-enter
          data-in={String(revealed)}
          sx={{
            position: 'absolute',
            inset: 0,
            transition: 'transform 1600ms ease-in-out 400ms',
            '&[data-in="true"]': { transform: 'rotate(360deg)' },
          }}
        >
          <Box
            sx={{
              position: 'absolute',
              left: '50%',
              top: '0.5%',
              width: '5.5%',
              aspectRatio: '1',
              borderRadius: '50%',
              backgroundImage: DOT,
              boxShadow: BISQUE.contact,
              transform: 'translate(-50%, -50%)',
            }}
          />
        </Box>
      </Box>

      <Box sx={{ ...CENTRED, width: '31.5%' }}>
        <BisqueRing size="art" state="empty" />
      </Box>
    </>
  );
}
